<script>
import { Line } from 'vue-chartjs';
import * as chartFormatting from '@/utilities/chart-formatting.js';
import debounce from 'lodash/debounce';

const data = [
  [
    4842962,
    5657173,
    6439890,
    7995478,
    11538167,
    11383727,
    14468979,
    15782476,
    20123103,
    25078508,
    30704761,
    34514419,
    39698317,
    46582841,
    53002905,
    63761228,
    72612893,
    80248553,
    87209345,
    101929875,
    111218852,
    119141015,
    129417869,
    143649269,
    138162291,
    137176287,
    129287212,
    155875284,
    167868110,
    184285072,
    217387264,
    245198279,
    255880946,
    354658773,
    430615425,
    436424449,
    464046269,
    496654805,
    516578617,
    537975434,
    566993838,
    606774361,
    623954951,
    671734911,
    705693724,
    778137562,
    766831212,
    821075550,
    860191571,
  ],
  [
    10497908,
    20050875,
    30814150,
    38609956,
    50495184,
    59017778,
    72283480,
    91608375,
    108638415,
    135413776,
    169365514,
    207563949,
    235910274,
    268273791,
    303347170,
    336372664,
    358105338,
    371992075,
    399215646,
    440083040,
    459786310,
    488136472,
    518242531,
    546723288,
    536593113,
    561206738,
    603031122,
    704540005,
    765612145,
    805939054,
    870180717,
    940983922,
    983535155,
    1092351493,
    1211278256,
    1148088436,
    1169479816,
    1186191611,
    1199119923,
    1193207275,
    1211110827,
    1249289587,
    1243393506,
    1278382458,
    1321878067,
    1415225049,
    1385631300,
    1473577157,
    1539614744,
  ]
];
const chartSpec = {
  labels: chartFormatting.determineXLabels(),
  datasets: [
    {
      backgroundColor: '#fdcb91',
      borderWidth: 1,
      data: data[0],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    },
    {
      borderWidth: 1,
      data: data[1],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    }
  ]
};
const chartOptions = {
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }
  },
  animation: {
    easing: chartFormatting.animationEasing,
    duration: chartFormatting.animationDuration
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 20,
          autoSkip: true,
          beginAtZero: true,
          fontColor: '#424242',
          fontFamily: chartFormatting.labelFontFamily,
          fontSize: 14,
          lineHeight: 3,
          maxTicksLimit: 10,
          callback: function (val) { // Format the dollars on the Y-Axis
            if (val >= 1000000000) { // $x.xB
              return '$' + (val / 1000000000) + 'B';
            } else if (val >= 1000000) { // $x.xM
              return '$' + (val / 1000000) + 'M';
            } else { // $xx,xxx
              return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        },
        gridLines: {
          drawTicks: false,
          display: false
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          zeroLineColor: 'transparent'
        },
        ticks: chartFormatting.xLabelFormat
      }
    ]
  }
};

export default {
  name: 'PolicyholdersSurplusChart',
  extends: Line,
  data: function () {
    return {
      chartSpec: chartSpec,
      chartOptions: chartOptions
    };
  },
  mounted () {
    this.resize();
    document.addEventListener('aos:in:policyholders-surplus-chart', this.aosChartEvent);
    this.handleDebouncedResize = debounce(this.resize, 50);
    window.addEventListener('resize', this.handleDebouncedResize);
  },
  beforeDestroy () {
    document.removeEventListener('aos:in:policyholders-surplus-chart', this.aosChartEvent);
    window.removeEventListener('resize', this.handleDebouncedResize);
  },
  methods: {
    aosChartEvent: function (event) {
      document.removeEventListener('aos:in:policyholders-surplus-chart', this.aosChartEvent);
      this.render();
    },
    render: function () {
      const ctx = this.$refs.canvas.getContext('2d');
      const container = $(this.$refs.canvas).parents('.chart-container');
      var gradientFill = (
        ctx.createLinearGradient(
          0,
          container.height() / 2,
          container.width(),
          container.height() / 2
        )
      );
      gradientFill.addColorStop(0, '#7AC9D5');
      gradientFill.addColorStop(1, '#1E4B66');
      this.chartSpec.datasets[1].backgroundColor = gradientFill;
      this.renderChart(this.chartSpec, this.chartOptions);
    },
    resize: function () {
      this.chartSpec.labels = chartFormatting.determineXLabels();
      this.render();
    }
  }
};
</script>
